import { useQuery } from '@apollo/client';
import type { UseSegmentReachFetch } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { GetSegmentReachByPkDocument } from '../../../graphql/query/segments/GetSegmentReachByPk.generated';

export const useSegmentReachFetch: UseSegmentReachFetch = (id: string) => {
  const {
    error,
    loading,
    data: { segment_by_pk: segmentReach } = {},
  } = useQuery(GetSegmentReachByPkDocument, { variables: { id } });

  return {
    error,
    loading,
    segmentReach,
  };
};
